import { ReportingTermRI } from '../rest-interfaces/reporting-term-ri';
import { TermIf } from '../interfaces/term-if';
import { i18n } from '../utils/i18n-util';

export class ReportingTerm implements TermIf {
  private uid: string;
  private schedulingTermUid: string;
  private reportingTermName: string;
  private startDate: string | Date;
  private endDate: string | Date;

  constructor(reportingTerm: ReportingTermRI) {
    this.uid = reportingTerm.uid;
    this.schedulingTermUid = reportingTerm.schedulingTermUid;
    this.reportingTermName = reportingTerm.reportingTermName;
    this.startDate = reportingTerm.startDate;
    this.endDate = reportingTerm.endDate;
  }

  getUid(): string {
    return this.uid;
  }

  getSchedulingTermUid(): string {
    return this.schedulingTermUid;
  }

  getReportingTermName(): string {
    return this.reportingTermName;
  }

  getStartDate(): Date {
    if (typeof this.startDate === 'string') {
      return i18n.parseJsonDate(this.startDate)!;
    }
    return <Date>this.startDate;

  }

  getEndDate(): Date {
    if (typeof this.endDate === 'string') {
      return i18n.parseJsonDate(this.endDate)!;
    }
    return <Date>this.endDate;
  }

  getName(): string {
    return this.reportingTermName;
  }
}
